import { RelativeDate } from './RelativeDate';

export const PostAuthor = ({
  name,
  createdAt,
  updatedAt,
}: {
  name: string;
  createdAt: string;
  updatedAt: string | null;
}) => {
  return (
    <div className="author">
      <h2 className="name">{name}</h2>
      <small className="date gray-date">
        {createdAt === updatedAt || updatedAt === null ? (
          <RelativeDate date={createdAt} />
        ) : (
          <>
            Edited <RelativeDate date={updatedAt} />
          </>
        )}
      </small>
    </div>
  );
};
